import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import {
    APIStatus,
    logout
} from "@/redux/modules/api/data/customer/customer.module";
import { getCustomer } from "@/redux/modules/api/data/customer/customer.selectors";
import * as SoftLoginService from "@/services/softLogin.service";
import { Config } from "@/utils/config.utils";

import { LogoutLinkComponent } from "./logoutLink.component";

type Props = {
    className?: string;
};

const LogoutLinkContainer = ({ className }: Props) => {
    const dispatch = useThunkDispatch();
    const customer = useSelector(getCustomer);

    const handleLogout = () => {
        if (customer) {
            dispatch(logout()).then((action) => {
                if (action.type === APIStatus.SUCCESS) {
                    location.assign(`${Config.pages.login}?logoutsuccess=true`);
                }
            });
        } else {
            SoftLoginService.clearSoftLogin();
            location.assign(Config.pages.login);
        }
    };

    return (
        <LogoutLinkComponent
            className={cn(className)}
            logout={handleLogout}
        />
    );
};

export { LogoutLinkContainer };
